import { Alert, Stack, Typography } from "@mui/material";
import { BlacklistResultsWithSearch } from "../../components/BlacklistNameSearch/types";

export default function BlackListSearchAlert({
  blackListSearchResults
}: {
  blackListSearchResults: BlacklistResultsWithSearch[];
}) {
  if (blackListSearchResults.length == 0) return <></>;
  const names = blackListSearchResults
    .flatMap((r) => r.results.map((inner) => inner.information))
    .map((name, index) => `${index + 1}) ${name}`)
    .join(", ");

  return (
    <Alert severity="error">
      <Stack direction="column" spacing={2}>
        <Typography variant="body1" sx={{ display: "inline" }}>
          DO NOT PROCEED! Blacklists matches found: {names}.{" "}
          <span style={{ fontWeight: "bold", color: "red" }}>DO NOT CONTINUE </span> transaction until confirmed in
          writing with your manager!
        </Typography>
      </Stack>
    </Alert>
  );
}
